/* eslint-disable eqeqeq */
import React, { useState } from 'react'
import { WebApi } from '../../api/web'
import { Loading, ShareButton } from '../../components/index'
import { FiHeart } from 'react-icons/fi'
import { UploadsUrl } from '../../services/url'

const TopSection = ({ like, setLike, lawyer, countLike, setCountLike, id }) => {
  const [loading, setLoading] = useState(false)

  const LikeDisLike = async () => {
    setLoading(true)
    await WebApi.likeDislike(id)
      .then((res) => {
        setLoading(false)
        if (res.data.data.likeLawyer.message == '1') {
          setCountLike(countLike + 1)
          setLike(true)
        } else {
          setCountLike(countLike - 1)
          setLike(false)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  return (
    <div className='top-section-single'>
      {loading && <Loading />}
      <div className='click-top-section' onClick={() => LikeDisLike()}>
        {like ? (
          <FiHeart size={25} fill={'#d81818'} color={'#d81818'} />
        ) : (
          <FiHeart size={25} />
        )}
        {countLike > 0 && <div className='count-Likes'>{countLike}</div>}
      </div>
      <div className='avatar'>
        <img
          className='box-shadow'
          src={`${UploadsUrl}/${lawyer.avatar}`}
          alt='user'
        />
      </div>
      <ShareButton url={window.location.href} />
    </div>
  )
}
export default TopSection
